import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import "core-js/modules/es.array.map.js";
import { computed, defineComponent, ref, toRefs } from "vue";
import { useStore } from "vuex";
import { useState } from "@/hooks/mapGet/index.js";
export default defineComponent({
  name: "artistListDetail",
  props: {
    albumList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var state = useState("player", ["currentId"]);
    var store = useStore();
    var isActive = ref(0);
    var maxLength = ref(10);

    var _toRefs = toRefs(props),
        albumList = _toRefs.albumList; //存储当前列表所有歌曲id为数组


    var songIds = computed(function () {
      return albumList.value.map(function (song) {
        return song.id;
      });
    });
    /* 歌曲点击事件 */

    var itemClick = function itemClick(id) {
      isActive.value = id; //播放当前歌曲

      store.dispatch("player/setSongListByIds", {
        ids: songIds.value,
        currentId: id
      });
    };
    /* 点击播放全部 */


    var songAllClick = function songAllClick(id) {
      store.dispatch("player/setSongListByIds", {
        ids: songIds.value,
        currentId: songIds.value[0]
      });
    };
    /* 热门歌曲50点击事件 */


    var hotTitleClick = function hotTitleClick() {
      maxLength.value = 50;
    };

    return _objectSpread(_objectSpread({}, state), {}, {
      isActive: isActive,
      maxLength: maxLength,
      itemClick: itemClick,
      hotTitleClick: hotTitleClick,
      songAllClick: songAllClick
    });
  },
  components: {}
});